<style scoped lang="less">
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
::-webkit-scrollbar {
  width: 10px;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        พิมพ์ QR Code
      </div>
      <v-spacer></v-spacer>

      <v-btn color="blue" dark @click="print_qr_car" class="mx-2">
        <v-icon left color="black">mdi-qrcode</v-icon>พิมพ์ QR-code รถ
      </v-btn>
      <v-btn color="blue" dark @click="print_qr_per" class="mx-2">
        <v-icon left color="black">mdi-qrcode</v-icon>พิมพ์ QR-code ลูกจ้าง
      </v-btn>
      <v-btn color="blue" dark @click="print_qr_cus" class="mx-2">
        <v-icon left color="black">mdi-qrcode</v-icon>พิมพ์ QR-code ลูกค้า
      </v-btn>
      <v-btn color="blue" dark @click="print_qr_qcar" class="mx-2">
        <v-icon left color="black">mdi-qrcode</v-icon>พิมพ์ QR-code คิวรถ
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-layout column class="pt-5 d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        <v-row>
          <v-col lg="6">
            <v-data-table
              v-model="selectedCar"
              :headers="headersCar"
              :items="getIndexCar"
              :single-select="singleSelectCar"
              :items-per-page="5"
              item-key="CAR_NUMBER"
              show-select
              class="elevation-1 mb-3"
            >
            </v-data-table>
          </v-col>
          <v-col lg="6">
            <v-data-table
              v-model="selectedPreson"
              :headers="headersPreson"
              :items="getIndexPerson"
              :single-select="singleSelectPreson"
              :items-per-page="5"
              item-key="id"
              show-select
              class="elevation-1"
            >
            </v-data-table>
          </v-col>
          <v-col lg="12">
            <filterCustomer
              :isfromNew="isfromNew"
              v-on:returnDessert="clickReturn"
              :fromPage="'qr_customer'"
            />
            <v-data-table
              v-model="selectedCustomer"
              :headers="headersCustomer"
              :items="getIndexCustomer"
              :single-select="singleSelectCustomer"
              item-key="NEWCUSTOMER_ID"
              show-select
              class="elevation-1"
            >
            </v-data-table>

            <div class="d-flex justify-space-around">
              <v-tabs>
                <v-tab
                  ><v-btn
                    class="ma-2 red lighten-1"
                    :loading="loadingSun"
                    :disabled="loadingSun"
                    @click="
                      (loader = 'loadingSun'), list_qeue('/list-qeue-sun')
                    "
                  >
                    อาทิตย์
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 yellow lighten-2"
                    :loading="loadingMon"
                    :disabled="loadingMon"
                    @click="
                      (loader = 'loadingMon'), list_qeue('/list-qeue-mon')
                    "
                  >
                    จันทร์
                  </v-btn></v-tab
                >
                <v-tab>
                  <v-btn
                    class="ma-2 pink accent-1"
                    :loading="loadingTue"
                    :disabled="loadingTue"
                    @click="
                      (loader = 'loadingTue'), list_qeue('/list-qeue-tue')
                    "
                  >
                    อังคาร
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 light-green accent-2"
                    :loading="loadingWed"
                    :disabled="loadingWed"
                    @click="
                      (loader = 'loadingWed'), list_qeue('/list-qeue-wed')
                    "
                  >
                    พุธ
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 orange accent-1"
                    :loading="loadingThu"
                    :disabled="loadingThu"
                    @click="
                      (loader = 'loadingThu'), list_qeue('/list-qeue-thu')
                    "
                  >
                    พฤหัสบดี
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 light-blue accent-1"
                    :loading="loadingFri"
                    :disabled="loadingFri"
                    color=""
                    @click="
                      (loader = 'loadingFri'), list_qeue('/list-qeue-fri')
                    "
                  >
                    ศุกร์
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 deep-purple accent-1"
                    :loading="loadingSat"
                    :disabled="loadingSat"
                    color=""
                    @click="
                      (loader = 'loadingSat'), list_qeue('/list-qeue-sat')
                    "
                  >
                    เสาร์
                  </v-btn></v-tab
                >
                <v-tab>
                  <v-btn
                    class="ma-2 cyan accent-1"
                    :loading="loadingAll"
                    :disabled="loadingAll"
                    @click="(loader = 'loadingAll'), list_qeue('/list-qeue-m1')"
                  >
                    รายเดือน/1
                  </v-btn></v-tab
                >
                <v-tab
                  ><v-btn
                    class="ma-2 blue lighten-3"
                    :loading="loadingAll2"
                    :disabled="loadingAll2"
                    @click="
                      (loader = 'loadingAll2'), list_qeue('/list-qeue-m2')
                    "
                  >
                    รายเดือน/2
                  </v-btn></v-tab
                >
              </v-tabs>
            </div>

            <v-tabs>
              <v-tab
                v-for="item in car_list"
                :key="item.tab"
                v-model="tab"
                @change="se_tab(item)"
              >
                <v-icon left> mdi-truck-outline </v-icon>
                {{ item.tab }}
              </v-tab>

              <v-tab-item v-for="item in car_list" :key="item.tab">
                <v-card flat>
                  <v-card-text>
                    <v-data-table
                      v-model="selectedQcar"
                      :headers="headers"
                      :items="dessertsReload"
                      show-select
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :single-select="singleSelectQcar"
                      item-key="RUN_NUMBER"
                      class="elevation-1 mb-3"
                    >
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import TableMenuProduct from "../components/TableMenuProduct";
import ProductForm from "./forms/ProductForm";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import print_QRcode_cus from "./pdf/print_QRcode_cus";
import filterCustomer from "../components/filterCustomer";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {
    TableMenuProduct,
    ProductForm,
    filterCustomer,
  },
  name: "Supply",
  data: () => ({
    isfromNew: false,
    upData: "",
    loader: null,
    loadingSun: false,
    loadingMon: false,
    loadingTue: false,
    loadingWed: false,
    loadingThu: false,
    loadingFri: false,
    loadingSat: false,
    loadingAll: false,
    loadingAll2: false,
    tab: null,
    carUpdate: "",
    car_list: [],
    reoadApi: "",
    headers: [
      { text: "รายชื่อ", value: "CUS_NAME", sortable: false },
      { text: "รหัสวางบิล", value: "BILL_ID", sortable: false, width: "100" },
      { text: "ที่อยู่", value: "CUS_ADDRESS", sortable: false },
      { text: "เบอร์โทร", value: "CUS_PHONE", sortable: false, width: "300" },
    ],
    desserts: [],
    Onclicked: "",
    keyCar_print: "",
    singleSelect: false,
    selected: [],
    dialog: false,
    dataCar: [],
    dataPerson: [],
    dataCustomer: [],
    singleSelectCustomer: false,
    singleSelectQcar: false,
    selectedCustomer: [],
    selectedQcar: [],
    singleSelectCar: false,
    selectedCar: [],
    singleSelectPreson: false,
    selectedPreson: [],
    headersCustomer: [
      // { text: "ลำดับ", value: "id", sortable: false, align: "start" },
      { text: "รหัสลูกค้า", sortable: false, value: "NEWCUSTOMER_ID" },
      { text: "รายชื่อลูกค้า", sortable: false, value: "CUSTOMER_NAME" },
      { text: "ประเภทสัญญา", sortable: false, value: "CONTRACT_CATEGORY" },
      { text: "สถานะ", sortable: false, value: "STATUS" },
    ],
    headersCar: [
      { text: "ลำดับ", value: "id", sortable: false, align: "start" },
      { text: "เลขทะเบียน", sortable: false, value: "CAR_NUMBER" },
      { text: "ยี่ห้อรถ", sortable: false, value: "CAR_GENERATION" },
    ],
    headersPreson: [
      { text: "ลำดับ", value: "id", sortable: false, align: "start" },
      { text: "ชื่อ", sortable: false, value: "PERSONNEL_NAME" },
      { text: "สกุล", sortable: false, value: "PERSONNEL_LASTNAME" },
      { text: "ตำแหน่ง", sortable: false, value: "PERSONNEL_POSITION" },
    ],
  }),
  watch: {},
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let z = isNaN(x) == true ? "0.00" : x;
      return z;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
    loader() {
      const l = this.loader;
      //console.log(l);

      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 2000);

      this.loader = null;
    },
  },
  computed: {
    getIndexCar() {
      return this.dataCar.map((item, index, PRICE) => ({
        ...item,
        id: index + 1,

        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    getIndexPerson() {
      return this.dataPerson.map((item, index, PRICE) => ({
        ...item,
        id: index + 1,

        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    getIndexCustomer() {
      return this.dataCustomer.map((item, index, PRICE) => ({
        ...item,
        id: index + 1,

        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    dessertsReload() {
      // console.log(this.desserts);
      return this.desserts;
    },
  },
  methods: {
    ...mapMutations({
      SET_CUS: "Qrcode/SET_ELEMENT_CUS",
      SET_CAR: "Qrcode/SET_ELEMENT_CAR",
      SET_PRESON: "Qrcode/SET_ELEMENT_PRESON",
      SET_STATEIS: "Qrcode/SET_STATEIS",
    }),
    listCar() {
      this.$token_api
        .get("/qr-car")
        .then((response) => {
          //console.log(response.data.data);
          this.dataCar = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listPerson() {
      this.$token_api
        .get("/qr-person")
        .then((response) => {
          //console.log(response.data.data);
          this.dataPerson = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    listCustomer() {
      this.$token_api
        .get("/qr-customer")
        .then((response) => {
          //console.log(response.data.data);
          this.dataCustomer = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async print_qr_cus() {
      if (this.selectedCustomer.length != 0) {
        this.SET_STATEIS("CUS");
        // เลือกเฉพาะเช็คถูก
        let aCus = this.selectedCustomer;
        // เลือกทั้งหมด
        // let aCus = this.getIndexCustomer;
        let rData = [];
        let lg = aCus.length;
        console.log("lg ", lg);
        for (let l = 0; l <= lg; l++) {
          // if (lg >= 7) lg -= 3;
          if (aCus.length) {
            let a = aCus.splice(0, 3);
            rData.push(a);
          }
        }
        //[1,2,3,4]
        //[1,2,3,4]
        //[1,2,,]

        this.SET_CUS(rData);
        this.SET_CAR("");
        this.SET_PRESON("");
        this.$router.push({ path: "/qr-code" });
      } else {
        this.$swal("ไม่พบข้อมูล ลูกค้า", "กด OK เพื่อย้อนกลับ", "error");
      }
    },
    async print_qr_qcar() {
      if (this.selectedQcar.length != 0) {
        this.SET_STATEIS("CUS");
        // เลือกเฉพาะเช็คถูก
        let aCus = this.selectedQcar;
        // เลือกทั้งหมด

        // let aCus = this.dessertsReload;
        let rData = [];
        let lg = aCus.length;
        for (let l = 0; l <= lg; l++) {
          // if (lg >= 7) lg -= 3;
          if (aCus.length) {
            let a = aCus.splice(0, 3);
            console.log(a);
            rData.push(a);
          }
        }
        //[1,2,3,4]
        //[1,2,3,4]
        //[1,2,,]

        this.SET_CUS(rData);
        this.SET_CAR("");
        this.SET_PRESON("");
        this.$router.push({ path: "/qr-code" });
      } else {
        this.$swal("ไม่พบข้อมูล ลูกค้า", "กด OK เพื่อย้อนกลับ", "error");
      }
    },
    async print_qr_car() {
      if (this.selectedCar.length != 0) {
        this.SET_STATEIS("CAR");
        // เลือกเฉพาะเช็คถูก
        let aCar = this.selectedCar;
        // เลือกทั้งหมด
        // let aCar = this.getIndexCar;
        let rData = [];
        let lg = aCar.length;
        for (let l = 0; l <= lg; l++) {
          if (lg >= 7) lg -= 3;
          if (aCar.length) {
            let a = aCar.splice(0, 3);
            rData.push(a);
          }
        }
        this.SET_CAR(rData);
        this.SET_CUS("");
        this.SET_PRESON("");
        this.$router.push({ path: "/qr-code" });
      } else {
        this.$swal("ไม่พบข้อมูล รถ", "กด OK เพื่อย้อนกลับ", "error");
      }
    },
    async print_qr_per() {
      if (this.selectedPreson.length != 0) {
        this.SET_STATEIS("PERSON");
        // เลือกเฉพาะเช็คถูก
        let aPer = this.selectedPreson;
        // เลือกทั้งหมด
        // let aPer = this.getIndexPerson;

        let rData = [];
        let lg = aPer.length;
        for (let l = 0; l <= lg; l++) {
          if (lg >= 7) lg -= 3;
          if (aPer.length) {
            let a = aPer.splice(0, 3);
            rData.push(a);
          }
        }
        this.SET_PRESON(rData);
        this.SET_CUS("");
        this.SET_CAR("");
        this.$router.push({ path: "/qr-code" });
      } else {
        this.$swal("ไม่พบข้อมูล พนักงาน", "กด OK เพื่อย้อนกลับ", "error");
      }
    },
    clickReturn(val) {
      this.dataCustomer = val;
    },
    se_tab(e) {
      //console.log(e);
      //console.log(this.upData );
      //this.update_qeue()
      this.carUpdate = e.tab;
      this.list_data_byCarnumber(e);
    },
    onMove(item) {
      //console.log(item);
      this.upData = item;
      //api update
    },
    list_qeue(api) {
      // console.log(api);
      this.Onclicked = api;
      this.reoadApi = api;

      this.$token_api
        .get(api)
        .then((response) => {
          let dataAll = response.data.data;
          //console.log('***********');
          //console.log(dataAll);
          let listQeue = [];
          for (const key in dataAll) {
            if (dataAll.hasOwnProperty(key)) {
              listQeue.push({ tab: dataAll[key].CAR_NUM });
            }
          }
          //Remove Duplicates tab In Array
          const filteredArr = listQeue.reduce((acc, current) => {
            const x = acc.find((item) => item.tab === current.tab);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
          //console.log(filteredArr);
          this.car_list = filteredArr;
          // console.log(this.car_list);
          this.list_data_byCarnumber(this.car_list[0]);
          this.carUpdate = this.car_list[0].tab;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    update_qeue() {
      // console.log(this.upData);
      this.$token_api
        .post("/qeue-update", this.upData)
        .then((res) => {
          //  console.log(res);
          this.list_qeue(this.reoadApi);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //flutter config --android-studio-dir="D:\Android"
    list_data_byCarnumber(e) {
      //select by CAR_NUMBER
      // console.log(this.Onclicked);
      this.$token_api
        .post("/post-data-by-car-number-web", {
          tab: e.tab,
          day_collect: this.Onclicked,
        })
        .then((res) => {
          let detailAll = res.data.data;
          let detailQeue = [];
          for (const key in detailAll) {
            if (detailAll.hasOwnProperty(key)) {
              detailQeue.push(detailAll[key]);
            }
          }

          this.desserts = detailQeue;

          // console.log(this.desserts);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadQeue() {
      var d = new Date();
      var n = d.getDay();
      var loopday = [
        "/list-qeue-sun",
        "/list-qeue-mon",
        "/list-qeue-tue",
        "/list-qeue-wed",
        "/list-qeue-thu",
        "/list-qeue-fri",
        "/list-qeue-sat",
      ];
      this.list_qeue(loopday[n]);
      // var a = "/list-qeue-all";
      // this.Onclicked = a;
      //this.list_qeue(a);
    },
  },
  mounted() {},
  created() {
    this.listCar();
    this.listPerson();
    this.listCustomer();
    this.reloadQeue();
  },
};
</script>
